import { FormControlLabel, Switch as SwitchUi } from "@mui/material";

export const Switch = ({ checked, name = undefined, onChange, label }: any) => {
  return (
    <FormControlLabel
      label={label}
      control={
        <SwitchUi
          onChange={onChange}
          checked={checked}
          name={name}
          color="primary"
        />
      }
    />
  );
};
